import { takeEvery } from "@redux-saga/core/effects";
import { call, put } from "redux-saga/effects";

import * as types from "../Types/ReportActionTypes";
import * as actions from "../Actions/ReportActions";
import { IGCPBigQueryJob } from "../../../Models/IGCPBigQueryJob";
import { deleteReport, getRecentReports, getReports } from "../API/ReportApi";
import { IGetJobsRequest } from "../Models/Requests/IGetJobsRequest";
import { App } from "../Enums/App";
import { IMyReportsReport } from "../../../Models/IMyReportsReport";

export function* watchReportSagas() {
    yield takeEvery(types.GET_REPORTS_INITIATE, getReportsSaga);
    yield takeEvery(types.DELETE_REPORT_INITIATE, deleteReportSaga);
    yield takeEvery(types.GET_RECENT_REPORTS_INITIATE, getRecentReportsSaga);
}

export function* getReportsSaga(action: types.ReportActionType) {
    try {
        yield put(actions.setLoadingReports(true));

        const jobs: IMyReportsReport[] = yield call(() =>
            getReports(action.data as IGetJobsRequest)
        );
        yield put(actions.getReportsSuccess(jobs));
    } catch (e) {
        yield put(actions.getReportsFailure(e));
    }
}

export function* deleteReportSaga(action: types.DeleteReportInitiateAction) {
    try {
        yield put(actions.setDeletingReport(true));
        yield call(() => deleteReport(action.data as string));
        yield put(actions.setDeletingReportSuccess(action.data as string));
    } catch (e) {
        // todo: handle error with toast or something
        yield put (actions.setDeletingReport(false));
    }
}

export function* getRecentReportsSaga(action: types.GetRecentReportsInitiateAction) {
    try {
        yield put(actions.setLoadingReports(true));
        const jobs: IGCPBigQueryJob[] = yield call(() =>
            getRecentReports({
                includeRetailMatch: action.data === App.MyReports ? true : action.data === App.Match,
                includeMobilytics: action.data === App.MyReports ? true : action.data === App.Mobilytics,
            })
        );
        if (action.data === App.Match) {
            yield put(actions.getRecentMatchReportsSuccess(jobs));
        } else if (action.data === App.Mobilytics) {
            yield put(actions.getRecentMobilyticsReportsSuccess(jobs));
        } else if (action.data === App.MyReports) {
            /* Update recentReports. Then filter, update recentMatchReports and recentMobilyticsReports */
            yield put(actions.getRecentReportsSuccess(jobs));
            const recentMobilyticsReports: IGCPBigQueryJob[] = [];
            const recentMatchReports: IGCPBigQueryJob[] = jobs.filter((item) => {
                if (item.jobType === "MOBILYTICS") {
                    recentMobilyticsReports.push(item);
                    return false;
                } else if (item.jobType === "RETAIL_MATCH") {
                    return true;
                } else {
                    return false;
                }
            });
            yield put(actions.getRecentMatchReportsSuccess(recentMatchReports));
            yield put(actions.getRecentMobilyticsReportsSuccess(recentMobilyticsReports));
        }
    } catch (e) {
        yield put(actions.getRecentReportsFailure(e));
    }
}
